import { useEffect, useState } from 'react';
import { Link } from 'react-router';

function Footer() {

    const [scrollToTopClass, setScrollToTopClass] = useState('scroll-to-top hidden');
    const handleScroll = () => {
        setScrollToTopClass(window.pageYOffset > 0 ? 'scroll-to-top' : 'scroll-to-top hidden');
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };

    }, []);

    function scrollToTop() {
        window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
    }

    return (
        <>
            <footer>
                <div className="foot-note">
                    <div className="container">
                        <div className="footer-content text-center text-lg-left  align-items-center">
                            <div className="footer-media">
                                <Link to="tel:+359887612233">
                                    <i className="fa fa-phone" aria-hidden="true"></i>+359887612233
                                </Link>   
                                <Link to="mailto:admin@vekota.bg">
                                    <i className="fa fa-envelope" aria-hidden="true"></i>admin@vekota.bg
                                </Link>
                            </div>
                            <hr />
                            <p className="mb-0 white-font">
                                Copyright &copy; 2026 |
                                Powered by Vekota.
                            </p>
                        </div>
                    </div>
                </div>
            </footer>

            <Link to="#" className={scrollToTopClass} id="scroll-to-top" onClick={scrollToTop}>
                <i className="fa-solid fa-arrow-up"></i>
            </Link>
        </>
    );
}

export default Footer;
